import { WarehouseElementLocation } from "components/WarehouseElements/WarehouseElementsData";

export function GetGridCoordonates(
  gridElementLocationSpan: WarehouseElementLocation[],
  etiquetteLocationSpan: WarehouseElementLocation
): WarehouseElementLocation {
  const location: WarehouseElementLocation = {
    start: {
      x: 0,
      y: 0,
    },
    end: {
      x: 0,
      y: 0,
    },
  };

  location.start.x = GetMinX(etiquetteLocationSpan, gridElementLocationSpan);
  location.start.y = GetMinY(etiquetteLocationSpan, gridElementLocationSpan);

  location.end!.x = GetMaxX(etiquetteLocationSpan, gridElementLocationSpan);
  location.end!.y = GetMaxY(etiquetteLocationSpan, gridElementLocationSpan);

  return location;
}

function GetMinX(
  etiquetteLocationSpan: WarehouseElementLocation,
  gridElementLocationSpan: WarehouseElementLocation[]
): number {
  return Math.min(
    etiquetteLocationSpan.start.x,
    ...gridElementLocationSpan.map(
      (locationInfos: WarehouseElementLocation) => locationInfos.start.x
    )
  );
}

function GetMaxX(
  etiquetteLocationSpan: WarehouseElementLocation,
  gridElementLocationSpan: WarehouseElementLocation[]
): number {
  return Math.max(
    etiquetteLocationSpan.end
      ? etiquetteLocationSpan.end.x
      : etiquetteLocationSpan.start.x,
    ...gridElementLocationSpan.map((locationInfos: WarehouseElementLocation) =>
      GetEndX(locationInfos)
    )
  );
}

function GetEndX(locationInfos: WarehouseElementLocation): number {
  return locationInfos.end ? locationInfos.end.x : locationInfos.start.x;
}

function GetMinY(
  etiquetteLocationSpan: WarehouseElementLocation,
  gridElementLocationSpan: WarehouseElementLocation[]
): number {
  return Math.min(
    etiquetteLocationSpan.start.y,
    ...gridElementLocationSpan.map(
      (locationInfos: WarehouseElementLocation) => locationInfos.start.y
    )
  );
}

function GetMaxY(
  etiquetteLocationSpan: WarehouseElementLocation,
  gridElementLocationSpan: WarehouseElementLocation[]
): number {
  return Math.max(
    etiquetteLocationSpan.end
      ? etiquetteLocationSpan.end.y
      : etiquetteLocationSpan.start.y,
    ...gridElementLocationSpan.map((locationInfos: WarehouseElementLocation) =>
      GetEndY(locationInfos)
    )
  );
}

function GetEndY(locationInfos: WarehouseElementLocation): number {
  return locationInfos.end ? locationInfos.end.y : locationInfos.start.y;
}
